import { type DocumentSpecification } from "../types/metagraphTypes";

interface ICreateDocumentSpecificationArgs {
    node_id: string;
    template_id?: string;
    additional_instructions?: string;
    patient?: string;
}

export function createDocumentSpecification({ node_id, template_id, additional_instructions, patient }: ICreateDocumentSpecificationArgs): DocumentSpecification {
    return {
        node_id,
        template_id,
        additional_instructions,
        patient,
        node_type: "MedicalNote",
    };
}